// extracted by mini-css-extract-plugin
export var info = "style-module--info--c1f38";
export var screen1 = "style-module--screen1--5dfeb";
export var textWrap = "style-module--text-wrap--d9b05";
export var timeWrap = "style-module--time-wrap--80aa2";
export var timer = "style-module--timer--e9d78";
export var timerWrap = "style-module--timer-wrap--0109f";
export var type = "style-module--type--eed83";
export var wrapper = "style-module--wrapper--556fe";